module.exports = "pegasus_template/assets/blocks/tile-layout-18.png";